export type SelfCampaignQueryParams = {
  email?: string;
  businessName?: string;
  name?: string;
  phone?: string;
  leadSubmissionId?: string;
};

const sanitizeTextParam = (value: string | null): string | undefined => {
  const trimmed = (value ?? "").trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

export const decodeEmailFromQueryParam = (
  value: string | null,
): string | undefined => {
  const decoded = (value ?? "").replace(/ /g, "+").trim().toLowerCase();
  return decoded.length > 0 ? decoded : undefined;
};

export const decodePhoneFromQueryParam = (
  value: string | null,
): string | undefined => {
  const decoded = (value ?? "").replace(/ /g, "+").trim();
  return decoded.length > 0 ? decoded : undefined;
};

export const getSelfCampaignQueryParams = (
  search: string,
): SelfCampaignQueryParams => {
  const params = new URLSearchParams(search);
  const leadSubmissionId =
    sanitizeTextParam(params.get("id")) ||
    sanitizeTextParam(params.get("leadSubmissionId"));

  return {
    email: decodeEmailFromQueryParam(params.get("email")),
    businessName: sanitizeTextParam(params.get("businessName")),
    name: sanitizeTextParam(params.get("name")),
    phone: decodePhoneFromQueryParam(params.get("phone")),
    leadSubmissionId,
  };
};
